export enum YearTypeEnum {
  SECOND_THIRD = '2-3년 차',
  FOURTH_SIXTH = '4-6년 차',
  SEVENTH_NINTH = '7-9년 차',
  TENTH_TWELFTH = '10-12년 차',
  OVER_THIRTEENTH = '13년 이상',
}

export type YearType = keyof typeof YearTypeEnum;
